import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { post_ForgotPassword } from '../../services/ForgotPassword';
import EmailValidatedComponent from '../../components/EmailValidatedComponent';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState<any>({
        emailAddress: "",
    });
    const [message, setMessage] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsProcessing(true);
        setMessage('');
        setErrorMessage('');

        post_ForgotPassword(userData.emailAddress)
            .then((res) => {
                if (res === userData.emailAddress) {
                    setMessage(`We've emailed a link to ${userData.emailAddress} to let you update your password. 
                        If you don't see the email, be sure to check your spam and junk mail folders.`);
                    setIsSuccess(true);
                } else {
                    setErrorMessage('Your email address does not exist.');
                }
                setIsProcessing(false);
                setUserData({ emailAddress: '' });
            })
            .catch((error) => {
                if (error.response && error.response.status === 500) {
                    setErrorMessage('There is some problem occurring. Please try again later.');
                } else {
                    setErrorMessage('Your email address does not exist.');
                }
                console.error(error);
                setIsProcessing(false);
            });
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center">Forgot Password</h2>
                {!isSuccess ? (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <EmailValidatedComponent
                                text={userData.emailAddress}
                                setText={(value) =>
                                    setUserData({ ...userData, emailAddress: value })
                                }
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={isProcessing}
                            className={`w-full ${isProcessing ? 'bg-gray-500' : 'bg-primary hover:bg-sky-600'} text-white font-bold py-2 px-4 rounded-[6px] focus:outline-none focus:shadow-outline`}
                        >
                            {isProcessing ? 'Processing...' : 'Reset Password'}
                        </button>
                    </form>
                ) : (
                    <div className="text-center">
                        <div className="mt-4 text-gray-800">{message}</div>
                        <button onClick={() => navigate("/login")}
                            className="mt-4 bg-primary text-white hover:bg-gray-600 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                            Go back to sign in
                        </button>
                    </div>
                )}
                {errorMessage && (
                    <div className="mt-4 text-center text-red-500">
                        {errorMessage}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;